var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPersona(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ai-persona_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "url(#ai-persona_svg__paint0_linear_2830_5483)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ai-persona_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.884 11.999c10.881 0 15.253 15.954 6.37 22.983-.884.698-.379 2.11.747 2.11v.007c8.09 0 15.068 5.443 15.717 12.937H53V66.78H7.233V55.533H7v-4.352c0-8.079 7.269-14.082 15.766-14.082.662 0 1.204-.531 1.204-1.193 0-1.305-2.065-1.33-3.962-5.437-3.8-8.204 1.355-18.47 9.876-18.47z",
    fill: "url(#ai-persona_svg__paint1_linear_2830_5483)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    stroke: "#93DAE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-persona_svg__paint0_linear_2830_5483",
    x1: 0,
    y1: 60,
    x2: 63.353,
    y2: 3.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-persona_svg__paint1_linear_2830_5483",
    x1: 7,
    y1: 66.78,
    x2: 62.824,
    y2: 25.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00CCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009AC0"
  })))));
}
export default __webpack_public_path__ + "fonts/ai-persona-e88ed6b95e8a94e6d4372567be0b6e0c.svg";
export { SvgAiPersona as ReactComponent };